import React from 'react';
import { Box, Skeleton } from '@mui/material';

const SkeletonLoader = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Skeleton variant="rectangular" height={200} sx={{ mb: 2, borderRadius: 2 }} />
      <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
      <Skeleton variant="text" height={30} sx={{ mb: 1 }} />
      <Skeleton variant="text" height={30} sx={{ mb: 1 }} />
      <Skeleton variant="text" height={30} sx={{ mb: 1 }} />
      <Skeleton variant="rectangular" height={100} sx={{ mb: 2, borderRadius: 2 }} />
      <Skeleton variant="text" height={30} sx={{ mb: 1 }} />
      <Skeleton variant="text" height={30} sx={{ mb: 1 }} />
    </Box>
  );
};

export default SkeletonLoader;